module.exports = __webpack_public_path__ + "assets/images/Audit-log.svg";